import utility from "../utility.js"
import { Auth } from "./../auth.js"

//マスタ操作
//一部の情報は再利用のため取得結果をキャッシュします。
export class MasterController {
    constructor(apiRootPath){
        apiRootPath ??= window.Setting.api
        this.url = apiRootPath + "master"

        //キャッシュ領域
        if(MasterController.saved == undefined)
            MasterController.saved = {}
    }

    //--------------------
    //システム設定
    /** GET master/config */
    async configRead(keys){
        let res = await Auth.ajax({
            url: `${this.url}/config`
                + (keys ? `?keys=${keys.join(",")}` : ""),
        })
        res.data = JSON.parse(res.body)
        return res
    }
    /** POST master/config */
    async configWrite(data){
        let res = await Auth.ajax({
            url: `${this.url}/config`,
            method: "POST",
            body: data,
        })
        return res
    }
    /** GET master/config/pause */
    async isPause(){
        let res = await Auth.ajax({
            url: `${this.url}/config/pause`
        })
        res.data = JSON.parse(res.body)
        return res
    }

    //--------------------
    //予約枠マスタ

    /** GET master/slot/list */
    async getSlotList(){
        let res = await this.request(`${this.url}/slot/list`, "GET")
        if(res.ok){
            res.data.forEach(x=>x["startOn"] = new Date(x["startOn"]*1000))
        }
        return res
    }
    /** GET master/slot */
    async getSlot(id){
        let res = await this.request(`${this.url}/slot/${id}`, "GET")
        if(res.ok){
            res.data["startOn"] = new Date(res.data["startOn"]*1000)
        }
        return res
    }
    /** POST master/slot */
    async writeSlot(data){
        let obj = JSON.parse(JSON.stringify(data))
        obj["startOn"] = new Date(obj["startOn"]).getTime()/1000

        return await this.request(`${this.url}/slot`, "POST", obj)
    }
    /** DELETE master/slot */
    async deleteSlot(id){
        return await this.request(`${this.url}/slot/${id}`, "DELETE")
    }

    //--------------------
    //休場日
    /** GET master/holiday/list */
    async getHolidayList(start, end){
        start = start.getTime() / 1000
        end = end.getTime() / 1000
        let res = await this.request(`${this.url}/holiday/list?start=${start}&end=${end}`, "GET")
        if(res.ok){
            res.data = JSON.parse(res.body).map(x=>new Date(x*1000))
        }
        return res
    }
    /** POST|DELETE master/holiday */
    async setHoliday(day, isHoliday){
        return await this.request(`${this.url}/holiday/${day.getTime()/1000}`, isHoliday ? "POST" : "DELETE")
    }

    //--------------------
    //和暦
    /** GET master/wareki/list */
    async getWarekiList(){
        let res = await this.request(`${this.url}/wareki/list`, "GET")
        if(res.ok){
            res.data.forEach(x=>x["startOn"] = utility.fromEpocSec(x["startOn"]))
        }
        return res
    }
    /** POST master/wareki */
    async writeWareki(data){
        let obj = {}
        Object.keys(data).forEach(x=>obj[x] = data[x])
        obj["startOn"] = utility.toEpochSec(data["startOn"])
        
        return await this.request(`${this.url}/wareki`, "POST", obj)
    }
    /** DELETE master/wareki */
    async deleteWareki(start){
        return await this.request(`${this.url}/wareki/${start.getTime() / 1000}`, "DELETE")
    }

    //--------------------
    //エリア
    /** GET master/area/list */
    async getAreaList(){
        return await this.request(`${this.url}/area/list`, "GET")
    }

    //--------------------
    //料金
    /** GET master/charge/list */
    async getChargeList(){
        let res = await this.request(`${this.url}/charge/list`, "GET")
        if(res.ok){
            res.data.forEach(x=>x["startOn"] = new Date(x["startOn"]*1000))
        }
        return res
    }
    /** GET master/charge */
    async getCharge(id){
        let res = await this.request(`${this.url}/charge/${id}`, "GET")
        if(res.ok){
            res.data["startOn"] = new Date(res.data["startOn"]*1000)
        }
        return res
    }
    /** POST master/charge */
    async writeCharge(data){
        let obj = JSON.parse(JSON.stringify(data))
        obj["startOn"] = new Date(obj["startOn"]).getTime()/1000

        return await this.request(`${this.url}/charge`, "POST", obj)
    }
    /** DELETE master/charge */
    async deleteCharge(id){
        return await this.request(`${this.url}/charge/${id}`, "DELETE")
    }

    //--------------------
    async request(path, method, data){
        let res = await Auth.ajax({
            url: `${path}`,
            method: method,
            body: data
        })
        if(res.ok && res.body != "") res.data = JSON.parse(res.body)
        return res
    }
}